import __request__ from "routing/request";
export function createConfig(config, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.archive/backends", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfigs(sort = "created_at", page = 1, per_page = 50, order = "asc", query, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/backends", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testOutputTemplate(template, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/backends/test-output-template", null, { "template": template }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfig(config, backendId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.archive/backends/${backendId}`, config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfig(backendId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.archive/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, delete_archives = false, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.archive/backends/${id}`, null, { "delete_archives": delete_archives }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
